import RequestAccessView from '@src/components/auth/requestAccess/RequestAccessView.tsx'

const RequestAccess = () => {
  return <RequestAccessView />
}

export default RequestAccess
